import { Search, SlidersHorizontal } from 'lucide-react';
import { Toolbar } from '@vnetwork/ui/layout';
import {
  Button,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuCheckboxItem,
  Input,
} from '@vnetwork/ui/primitives';
import type { ColumnDef } from '@vnetwork/ui/data';
import type { SurveyRecord } from '@/api/surveys';

type Col = ColumnDef<SurveyRecord, unknown>;

export interface SurveysToolbarProps {
  columns: Col[];
  query: string;
  onQueryChange: (v: string) => void;
  visible: Record<string, boolean>;
  onToggleColumn: (id: string, checked: boolean) => void;
}

/**
 * Surveys list toolbar: search input (start) + Display-options column-visibility
 * dropdown (end). No FilterBuilder wired here — filter support can be added when
 * the backend filter params are needed. Follows the canonical toolbar recipe.
 */
export function SurveysToolbar({
  columns,
  query,
  onQueryChange,
  visible,
  onToggleColumn,
}: SurveysToolbarProps) {
  return (
    <Toolbar
      style={{ marginBottom: 0 }}
      start={
        <Input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search by customer name…"
          startSlot={<Search size={15} />}
          style={{ maxWidth: 320 }}
        />
      }
      end={
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="secondary" startIcon={<SlidersHorizontal size={15} />}>
              Display options
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Edit columns</DropdownMenuLabel>
            {columns.map((c) => {
              const id = c.id as string;
              return (
                <DropdownMenuCheckboxItem
                  key={id}
                  checked={visible[id] !== false}
                  onCheckedChange={(v) => onToggleColumn(id, v === true)}
                  onSelect={(e) => e.preventDefault()}
                >
                  {typeof c.header === 'string' ? c.header : id}
                </DropdownMenuCheckboxItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      }
    />
  );
}
